import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { TradesTable } from '../../../../../../../../../../features/trade/trades-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsTrade,
      label: 'UTC Match',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsTrade>,
  head: () => getPageHead('UTC Trades'),
  component: UTCTradeList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsTrade}
    />
  );
}

function UTCTradeList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TradesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
